export const removeSearchParams = (keysToRemove: string[], currentParams: URLSearchParams): URLSearchParams | null => {
  const newParams = new URLSearchParams(currentParams.toString());
  let hasChanges = false;

  keysToRemove.forEach((key) => {
    if (newParams.has(key)) {
      newParams.delete(key);
      hasChanges = true;
    }
  });

  return hasChanges ? newParams : null;
};
